import type { StoryNode } from '@/engine/types'

import { bondEndingNode } from './bondEnding'
import { cgPath } from '../cgAssets'

// 三组线把同一轮冲突视为人才与联盟机会，核心代价是“吸收人数”不等于“吸收忠诚”。
export const route3Nodes = [
  {
    id: 'r3-00-founded',
    chapter: 'prologue',
    actLabel: '序章 · 吸收不是拥有',
    date: '2026-07-19',
    title: '抚梅观清雪成立',
    location: '组织大厅',
    mode: 'system',
    speaker: 'system',
    text: '组织「抚梅观清雪」创建成功。首领：{{player}}。高层：心跳成瘾、真理。公告刚发出，心跳成瘾已经打开了招募频道，真理则在第一页规则上留出签字处。',
    background: 'organization',
    music: 'groupChat',
    historical: 'adapted',
    presentation: {
      cg: cgPath('cg23-route3-founding'),
      cgAlt: '抚梅观清雪成立之夜，心跳成瘾指向空缺成员席位，真理抱着尚未启用的规则册',
      ui: 'cinematic',
      transition: 'ink',
      camera: 'pull-back',
      atmosphere: 'petals',
      focus: 'center',
    },
    onEnter: [
      { type: 'highCouncil', members: ['heartbeat', 'truth'] },
      { type: 'stance', character: 'heartbeat', value: 'support' },
      { type: 'relationship', character: 'heartbeat', key: 'trust', value: 1 },
      { type: 'relationshipProgress', character: 'heartbeat', value: 5 },
      { type: 'relationship', character: 'truth', key: 'trust', value: 1 },
      { type: 'unlockCg', id: 'cg23-route3-founding' },
    ],
    next: 'r3-01-growth-contract',
  },
  {
    id: 'r3-01-growth-contract',
    chapter: 'prologue',
    actLabel: '序章 · 吸收不是拥有',
    date: '2026-07-19',
    location: '管理私聊',
    mode: 'chat',
    speaker: 'heartbeat',
    portrait: 'heartbeat',
    text: '招募频道我能去聊，位置我一个都不会先许。真把人请到门口了，你想先给他们看规则，还是先请进来再排位置？',
    background: 'organization',
    // 建组系统镜头延续到首个选择，避免点击后突然退回通用组织背景。
    presentation: {
      cg: cgPath('cg23-route3-founding'),
      cgAlt: '心跳成瘾与真理分别代表扩张和规则，等待玩家决定三组的第一份招募原则',
      ui: 'classic',
      transition: 'crossfade',
      camera: 'push-in',
      atmosphere: 'petals',
      focus: 'left',
    },
    choices: [
      {
        id: 'rules-before-people',
        label: '“职位和奖励先写清，写完再拉人。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'org3RulesBeforeRecruitment' },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'relationship', character: 'truth', key: 'trust', value: 2 },
          { type: 'relationship', character: 'heartbeat', key: 'trust', value: 1 },
          { type: 'relationshipProgress', character: 'heartbeat', value: 10 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'r3-01b-rules-reply',
      },
      {
        id: 'take-talent-first',
        label: '“先把人请来，但谁也别先许高层。”',
        tone: 'bold',
        effects: [
          { type: 'flag', key: 'org3TalentFirst' },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'relationship', character: 'heartbeat', key: 'trust', value: 2 },
          { type: 'relationship', character: 'heartbeat', key: 'affinity', value: 1 },
          { type: 'relationshipProgress', character: 'heartbeat', value: 15 },
          { type: 'relationship', character: 'truth', key: 'trust', value: -1 },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
        ],
        next: 'r3-01c-talent-reply',
      },
    ],
  },
  {
    // 建组原则先变成真理和心跳可执行的招募动作。
    id: 'r3-01b-rules-reply', chapter: 'prologue', actLabel: '序章 · 吸收不是拥有', date: '2026-07-19',
    location: '抚梅观清雪 · 管理群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '我先把空位、轮换和奖励写出来。新人进群第一眼看见的是边界，不是我们还没兑现的头衔。',
    background: 'organization', historical: 'fictional', next: 'r3-01a-first-inbox',
  },
  {
    id: 'r3-01c-talent-reply', chapter: 'prologue', actLabel: '序章 · 吸收不是拥有', date: '2026-07-19',
    location: '抚梅观清雪 · 招募私聊', mode: 'chat', speaker: 'heartbeat', portrait: 'heartbeat',
    text: '那我先把人叫来，邀请里写清“先贡献，后位置”。人先进门会快很多，但每个“我以为”都会回来找我们。',
    background: 'recruitment', historical: 'fictional', next: 'r3-01a-first-inbox',
  },
  {
    id: 'r3-01a-first-inbox',
    chapter: 'prologue',
    actLabel: '序章 · 吸收不是拥有',
    date: '2026-07-19',
    location: '抚梅观清雪 · 招募私聊',
    mode: 'chat',
    speaker: 'heartbeat',
    portrait: 'heartbeat',
    text: '第一批回复有七个。我只说了“进群先聊”，没说进来就有职位。你把刚才那句记住，以后别让我替你兑现。',
    background: 'recruitment',
    sound: 'message',
    historical: 'fictional',
    next: {
      cases: [
        { when: { type: 'flag', key: 'org3RulesBeforeRecruitment' }, next: 'r3-01d-rules-echo' },
        { when: { type: 'flag', key: 'org3TalentFirst' }, next: 'r3-01e-talent-echo' },
      ],
      fallback: 'r3-02-shi-transfer',
    },
  },
  {
    id: 'r3-01d-rules-echo', chapter: 'prologue', actLabel: '序章 · 吸收不是拥有', date: '2026-07-19',
    location: '抚梅观清雪 · 招募私聊', mode: 'chat', speaker: 'heartbeat', portrait: 'heartbeat',
    text: '七个人先问的是轮换和奖励，不是职位。你把空位写在前面，他们看完还愿意等，这比一句“以后再说”管用。',
    background: 'recruitment', historical: 'fictional', next: 'r3-02-shi-transfer',
  },
  {
    id: 'r3-01e-talent-echo', chapter: 'prologue', actLabel: '序章 · 吸收不是拥有', date: '2026-07-19',
    location: '抚梅观清雪 · 招募私聊', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '七个人都进来了，已经有两个在问什么时候分位置。人先来了，解释就不能晚到他们自己编出答案。',
    background: 'recruitment', historical: 'fictional', next: 'r3-02-shi-transfer',
  },
  {
    id: 'r3-02-shi-transfer',
    chapter: 'prologue',
    actLabel: '序章 · 吸收不是拥有',
    date: '2026-07-19',
    location: '世界频道',
    mode: 'system',
    speaker: 'system',
    text: '【成员变动】原五组高层「时」于7月19日加入二组江南，当前职位：普通成员。',
    background: 'recruitment',
    historical: 'confirmed',
    presentation: {
      cg: cgPath('cg31-shi-joins-org2'),
      cgAlt: '三组从外部看见时于7月19日以普通成员身份加入江南，尚未获得任何高层位置',
      ui: 'cinematic',
      transition: 'crossfade',
      camera: 'pull-back',
      atmosphere: 'dust',
      focus: 'left',
    },
    onEnter: [
      { type: 'flag', key: 'shiJoinedOrg2OnJuly19' },
      { type: 'unlockCg', id: 'cg31-shi-joins-org2' },
    ],
    next: 'r3-02a-shi-lesson',
  },
  {
    id: 'r3-02a-shi-lesson',
    chapter: 'prologue',
    actLabel: '序章 · 吸收不是拥有',
    date: '2026-07-19',
    location: '抚梅观清雪 · 管理群',
    mode: 'chat',
    speaker: 'truth',
    portrait: 'truth',
    text: '我把截图存了。这只能证明时转组后是普通成员，不能证明二组曾经答应过他什么。“不知道”也要写进记录。',
    background: 'organization',
    historical: 'fictional',
    next: 'r3-03-incomplete-screenshot',
  },
  {
    id: 'r3-03-incomplete-screenshot',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    title: '一张从四组来的图',
    location: '三组管理群',
    mode: 'chat',
    speaker: 'truth',
    portrait: 'truth',
    text: '我现在能确认两件事：takemehand被辰逸禁言，截图缺了开头。至于他们之前说了什么，我没证据。辰逸已经在区群点名三组，你决定先查还是先回。',
    background: 'worldChat',
    music: 'worldEnemy',
    historical: 'adapted',
    choices: [
      {
        id: 'request-complete-context',
        label: '把两边的完整记录都要来',
        tone: 'calm',
        effects: [
          { type: 'stat', key: 'evidence', value: 2 },
          { type: 'relationship', character: 'truth', key: 'trust', value: 2 },
          { type: 'organizationRelation', organization: 'org4', value: 1 },
          { type: 'flag', key: 'org3VerifiedScreenshot' },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'r3-03b-request-context-reply',
      },
      {
        id: 'use-partial-screenshot',
        label: '拿现有截图进区群：“二组先道歉。”',
        tone: 'bold',
        effects: [
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'relationship', character: 'truth', key: 'trust', value: -1 },
          { type: 'organizationRelation', organization: 'org2', value: -1 },
          { type: 'flag', key: 'org3UsedPartialScreenshot' },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
        ],
        next: 'r3-03c-partial-screenshot-reply',
      },
      {
        id: 'treat-as-private',
        label: '收起截图：“先按二组内部事件处理。”',
        tone: 'calm',
        effects: [{ type: 'stat', key: 'cohesion', value: 1 }, { type: 'butterflyDelta', key: 'bf_shadow', delta: 1 }],
        next: 'r3-03d-private-event-reply',
      },
    ],
  },
  {
    // 证据决策先让真理回应可执行的下一步，再进入共同核验结果。
    id: 'r3-03b-request-context-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '三组管理群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '我分别去要原图和聊天导出，不让任何一边用转发图代替记录。辰逸可能会先开口，我们不跟他抢结论。',
    background: 'worldChat', historical: 'fictional', next: 'r3-03a-truth-crosscheck',
  },
  {
    id: 'r3-03c-partial-screenshot-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '三组管理群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '你可以先发，但我不会在“完整记录”下面签名。缺的三句以后一旦出现，区群会先问我们为什么故意没等。',
    background: 'worldChat', historical: 'fictional', next: 'r3-03a-truth-crosscheck',
  },
  {
    id: 'r3-03d-private-event-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '三组管理群', mode: 'chat', speaker: 'heartbeat', portrait: 'heartbeat',
    text: '那我先把三组的人叫回自己群，不去公频当陪审团。但辰逸若继续点三组的名，这件事就会自己走出“内部”。',
    background: 'worldChat', historical: 'fictional',
    onEnter: [{ type: 'flag', key: 'org3KeptScreenshotPrivate' }],
    next: 'r3-03a-truth-crosscheck',
  },
  {
    id: 'r3-03a-truth-crosscheck',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '三组管理群',
    mode: 'chat',
    speaker: 'truth',
    portrait: 'truth',
    text: '两张图的时间戳对上了，中间仍然少三句。我会把“缺失”标出来，不会用猜的句子补齐。区群又有新消息了。',
    background: 'worldChat',
    sound: 'message',
    historical: 'fictional',
    next: {
      cases: [
        { when: { type: 'flag', key: 'org3VerifiedScreenshot' }, next: 'r3-03e-complete-echo' },
        { when: { type: 'flag', key: 'org3UsedPartialScreenshot' }, next: 'r3-03f-partial-echo' },
        { when: { type: 'flag', key: 'org3KeptScreenshotPrivate' }, next: 'r3-03g-private-echo' },
      ],
      fallback: 'r3-04-world-enemy',
    },
  },
  {
    id: 'r3-03e-complete-echo', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '三组管理群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '三句仍然缺着，但原图来源和时间戳已经对上。现在可以带着缺口说话，不必把它伪装成完整结论。',
    background: 'worldChat', historical: 'fictional', next: 'r3-04-world-enemy',
  },
  {
    id: 'r3-03f-partial-echo', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '4945区群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '残图的来源和缺口我都补在第一行了。辰逸追问时，三组的第一句只能是“这一段没有证据”。',
    background: 'worldChat', historical: 'fictional', next: 'r3-04-world-enemy',
  },
  {
    id: 'r3-03g-private-echo', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '三组管理群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '内部核验已经存档，公开时机仍然留给你。但三组没有发言，只能证明我们当时沉默，不能证明任何人是对的。',
    background: 'worldChat', historical: 'fictional', next: 'r3-04-world-enemy',
  },
  {
    id: 'r3-04-world-enemy',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    title: '与世界为敌',
    location: '4945区群',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: '三组拿张残图就来装公正？你们首领要站队就直接说，别一边挖人一边讲程序。',
    background: 'worldChat',
    sound: 'warning',
    historical: 'confirmed',
    presentation: {
      cg: cgPath('cg27-world-enemy'),
      cgAlt: '辰逸在4945区公共群把三组写进争执，消息流同时扩向一组和四组',
      ui: 'classic',
      transition: 'glitch',
      camera: 'push-in',
      atmosphere: 'messages',
      focus: 'left',
    },
    onEnter: [
      { type: 'flag', key: 'worldEnemyStartedOnJuly20' },
      { type: 'unlockCg', id: 'cg27-world-enemy' },
    ],
    next: 'r3-05-public-response',
  },
  {
    id: 'r3-05-public-response',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '4945区群',
    mode: 'novel',
    speaker: 'heartbeat',
    portrait: 'heartbeat',
    text: '他把三组写进去了。我能把四组的人拉来回话，但不会替他们答应站队。你先定这是辰逸个人的话，还是二组在对三组说话。',
    background: 'worldChat',
    // The first public ruling leaves chat chrome so Heartbeat can carry the decision as a VN close-up.
    presentation: {
      ui: 'classic', transition: 'slide', camera: 'push-in', atmosphere: 'messages',
      sprites: [{ character: 'heartbeat', expression: 'concerned', pose: 'phone', position: 'left', scale: 1.02 }],
    },
    choices: [
      {
        id: 'personal-response',
        label: '“只核对事实，不替全组织开战。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'org3TreatedAttackAsPersonal' },
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'stat', key: 'cohesion', value: -1 },
          { type: 'organizationRelation', organization: 'org2', value: 1 },
          { type: 'relationship', character: 'truth', key: 'trust', value: 1 },
          { type: 'relationshipProgress', character: 'heartbeat', value: 5 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'r3-05b-personal-ruling-reply',
      },
      {
        id: 'organizational-condemnation',
        label: '“这是组织越界。二组撤掉涉事高层。”',
        tone: 'bold',
        effects: [
          { type: 'flag', key: 'org3CondemnedOrg2' },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'organizationRelation', organization: 'org2', value: -2 },
          { type: 'organizationRelation', organization: 'org4', value: 1 },
          { type: 'relationship', character: 'heartbeat', key: 'trust', value: 1 },
          { type: 'relationshipProgress', character: 'heartbeat', value: 15 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
        ],
        next: 'r3-05c-organization-ruling-reply',
      },
      {
        id: 'publish-evidence-standard',
        label: '把“已知、未知、要求”三栏贴进区群',
        tone: 'secret',
        condition: { type: 'flag', key: 'org3VerifiedScreenshot' },
        effects: [
          { type: 'flag', key: 'org3EvidenceStatement' },
          { type: 'stat', key: 'reputation', value: 2 },
          { type: 'relationship', character: 'truth', key: 'trust', value: 2 },
          { type: 'relationshipProgress', character: 'heartbeat', value: 10 },
          { type: 'organizationRelation', organization: 'org2', value: -1 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'r3-05d-evidence-standard-reply',
      },
    ],
  },
  {
    id: 'r3-05b-personal-ruling-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '4945区群', mode: 'chat', speaker: 'heartbeat', portrait: 'heartbeat',
    text: '那我只回辰逸本人：把原记录补齐，别拿二组的名字压三组。这句话不带战书，也不替他的组织免责。',
    background: 'worldChat', historical: 'fictional', next: 'r3-05a-public-room',
  },
  {
    id: 'r3-05c-organization-ruling-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '4945区群', mode: 'chat', speaker: 'heartbeat', portrait: 'heartbeat',
    text: '我会把“撤掉涉事高层”写清楚。从这一刻起，二组若不处理，就不再是一个人的回话，是组织对我们的答复。',
    background: 'worldChat', historical: 'fictional', next: 'r3-05a-public-room',
  },
  {
    id: 'r3-05d-evidence-standard-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '4945区群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '三栏已经发出去：已知的只写时间戳，未知的保留空白，要求只有“补原记录”。谁想把空白填成立场，得自己署名。',
    background: 'worldChat', historical: 'fictional', next: 'r3-05a-public-room',
  },
  {
    id: 'r3-05a-public-room',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '抚梅观清雪 · 组织群',
    mode: 'chat',
    speaker: 'heartbeat',
    portrait: 'heartbeat',
    text: '我把能回来的人都叫回来了。没人替我们承诺宣战，也没人因为进语音就有职位。现在一组首领在问你，联合声明签不签。',
    background: 'worldChat',
    historical: 'fictional',
    next: {
      cases: [
        { when: { type: 'flag', key: 'org3EvidenceStatement' }, next: 'r3-05e-evidence-echo' },
        { when: { type: 'flag', key: 'org3CondemnedOrg2' }, next: 'r3-05f-condemn-echo' },
        { when: { type: 'flag', key: 'org3TreatedAttackAsPersonal' }, next: 'r3-05g-personal-echo' },
      ],
      fallback: 'r3-06-qifu-pressure',
    },
  },
  {
    id: 'r3-05e-evidence-echo', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '抚梅观清雪 · 组织群', mode: 'chat', speaker: 'heartbeat', portrait: 'heartbeat',
    text: '祈福说联合声明可以附上三栏原文。谁要签名，先看清“未知”那一栏，不准签完再说自己没看见。',
    background: 'worldChat', historical: 'fictional', next: 'r3-06-qifu-pressure',
  },
  {
    id: 'r3-05f-condemn-echo', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '抚梅观清雪 · 组织群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '二组还没回是否撤人。我们已经把事件定义为组织越界，接下来每一个人的站位都会被当成组织回答。',
    background: 'worldChat', historical: 'fictional', next: 'r3-06-qifu-pressure',
  },
  {
    id: 'r3-05g-personal-echo', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '抚梅观清雪 · 组织群', mode: 'chat', speaker: 'heartbeat', portrait: 'heartbeat',
    text: '一组在问要不要联署。我会先把你那句“只核事实，不替全组织开战”转给祈福，免得他把沉默当默认。',
    background: 'worldChat', historical: 'fictional', next: 'r3-06-qifu-pressure',
  },
  {
    id: 'r3-06-qifu-pressure',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '首领私聊',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '一组会要求二组给正式说法。联合声明我写好了，但不会替你加名字。三组是联署、单独发，还是只和我私下说？',
    background: 'worldChat',
    choices: [
      {
        id: 'join-pressure',
        label: '在联合声明下签上“三组·抚梅观清雪”',
        tone: 'bold',
        effects: [
          { type: 'flag', key: 'org3JoinedOrg1Pressure' },
          { type: 'organizationRelation', organization: 'org1', value: 1 },
          { type: 'relationship', character: 'qifu', key: 'trust', value: 1 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
        ],
        next: 'r3-06a-joined-reply',
      },
      {
        id: 'independent-position',
        label: '“不联署。三组自己说清自己的判断。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'org3IndependentStatement' },
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'relationship', character: 'qifu', key: 'trust', value: -1 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'r3-06b-independent-reply',
      },
      {
        id: 'private-qifu-talk',
        label: '私聊祈福：“管理员身份不是证据。”',
        tone: 'warm',
        effects: [
          { type: 'flag', key: 'privateTalkWithQifu' },
          { type: 'relationship', character: 'qifu', key: 'trust', value: 3 },
          { type: 'relationship', character: 'qifu', key: 'affinity', value: 2 },
          { type: 'relationshipProgress', character: 'qifu', value: 60 },
          { type: 'stat', key: 'evidence', value: 1 },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
        ],
        next: 'r3-06c-private-reply',
      },
    ],
  },
  {
    id: 'r3-06a-joined-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '首领私聊', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '签名收到。我把三组放进联合声明，但公开压力有人接，后果也得有人解释；这个名字不是装饰。',
    background: 'worldChat', historical: 'fictional', next: 'r3-07-group-explosion',
  },
  {
    id: 'r3-06b-independent-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '首领私聊', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '好，我不把三组塞进联合声明。你们单独发时，我会把一组的联署放在旁边，不混成一条命令。',
    background: 'worldChat', historical: 'fictional', next: 'r3-07-group-explosion',
  },
  {
    id: 'r3-06c-private-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '祈福私聊', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '明白，管理员身份不等于证据。这句我留在私聊，不逼你公开站队；但我接下来给权限时会记着。',
    background: 'nightMessage', historical: 'fictional', next: 'r3-07-group-explosion',
  },
  {
    id: 'r3-07-group-explosion',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-20',
    title: '管理员的第一次政变',
    location: '旧4945区群',
    mode: 'system',
    speaker: 'system',
    text: '希露菲从老区来新区找乐子，向祈福谎称自己是组织高层，骗到管理员权限。随后，群里所有能够移除的成员被逐个踢出。',
    background: 'twoGroups',
    sound: 'warning',
    historical: 'confirmed',
    presentation: {
      cg: cgPath('cg14-xilufei-explosion'),
      cgAlt: '希露菲向祈福谎称自己是高层，骗到管理员后清空所有能够移除的群成员',
      ui: 'cinematic',
      transition: 'glitch',
      atmosphere: 'paper',
      focus: 'center',
    },
    onEnter: [
      { type: 'flag', key: 'oldGroupBombed' },
      { type: 'unlockCg', id: 'cg14-xilufei-explosion' },
    ],
    next: 'r3-07a-kicked-window',
  },
  {
    id: 'r3-07a-kicked-window',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-20',
    location: '旧4945区群',
    mode: 'chat',
    speaker: 'truth',
    portrait: 'truth',
    text: '我这边已经变成“群聊不存在”了。被踢出QQ群不等于游戏封号，三组成员还在客户端。先把谁还在线记下来，别在两个名字一样的群里重复下命令。',
    background: 'twoGroups',
    sound: 'warning',
    historical: 'adapted',
    next: 'r3-08-choose-public-group',
  },
  {
    id: 'r3-08-choose-public-group',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-21',
    location: '两个4945群',
    mode: 'novel',
    speaker: 'truth',
    portrait: 'truth',
    text: '旧群有一组的管理员，新群由二组拉人。两边都叫“官方”，客户端没给任何一边认证。你说三组的公告往哪发，我就把核验规则写在后面。',
    background: 'twoGroups',
    choices: [
      {
        id: 'stay-old-group',
        label: '留一个联络员在旧群：“管理员名单先公开。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'org3RecognizesOldGroup' },
          { type: 'organizationRelation', organization: 'org1', value: 1 },
          { type: 'organizationRelation', organization: 'org2', value: -1 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
        ],
        next: 'r3-08a-old-group-reply',
      },
      {
        id: 'join-both-groups',
        label: '两个群各留一人，只转发能交叉核对的消息',
        tone: 'secret',
        effects: [
          { type: 'flag', key: 'org3InBothGroups' },
          { type: 'stat', key: 'evidence', value: 2 },
          { type: 'stat', key: 'reputation', value: -1 },
          { type: 'relationship', character: 'truth', key: 'trust', value: 1 },
          { type: 'butterflyDelta', key: 'bf_shadow', delta: 1 },
        ],
        next: 'r3-08b-both-groups-reply',
      },
      {
        id: 'recognize-neither',
        label: '“两个群都不背书，只保留首领直联。”',
        tone: 'bold',
        effects: [
          { type: 'flag', key: 'org3RecognizesNeitherGroup' },
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'stat', key: 'resources', value: -1 },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
        ],
        next: 'r3-08c-neither-group-reply',
      },
    ],
  },
  {
    id: 'r3-08a-old-group-reply', chapter: 'act2', actLabel: '第二幕 · 两个4945', date: '2026-07-21',
    location: '旧4945区群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '旧群留一个联络员，管理员名单每天导出一次。公告可以留副本，真正的命令仍然要回三组群确认。',
    background: 'twoGroups', historical: 'fictional', next: 'r3-09-xilufei-exits',
  },
  {
    id: 'r3-08b-both-groups-reply', chapter: 'act2', actLabel: '第二幕 · 两个4945', date: '2026-07-21',
    location: '两个4945群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '两边各留一人，但单张截图不下命令。同一条消息至少要在两边对上时间和发件人，否则只写“待核”。',
    background: 'twoGroups', historical: 'fictional', next: 'r3-09-xilufei-exits',
  },
  {
    id: 'r3-08c-neither-group-reply', chapter: 'act2', actLabel: '第二幕 · 两个4945', date: '2026-07-21',
    location: '抚梅观清雪 · 组织群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '两个群都不背书，我只保留首领直联。这会更慢，也会少掉一些提醒；但没人能借“官方”两个字给三组下命令。',
    background: 'twoGroups', historical: 'fictional', next: 'r3-09-xilufei-exits',
  },
  {
    id: 'r3-09-xilufei-exits',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-21',
    location: '区服简报',
    mode: 'system',
    speaker: 'system',
    text: '【7月21日】二组首领拒绝向一组开战；希露菲退出二组群和二组。祈福在战区群过度@全体，管理员权限被撤回。',
    background: 'twoGroups',
    historical: 'confirmed',
    // Reuse the dedicated departure frame instead of a fourth consecutive two-group backdrop.
    presentation: {
      cg: cgPath('cg15-xilufei-exit'),
      cgAlt: '江南首领拒绝向一组开战后，希露菲于7月21日退出二组群并离开江南',
      ui: 'cinematic', transition: 'crossfade', camera: 'pull-back', atmosphere: 'dust', focus: 'right',
    },
    onEnter: [
      { type: 'flag', key: 'xilufeiLeftOnJuly21' },
      { type: 'flag', key: 'qifuLostWarzoneAdmin' },
      { type: 'unlockCg', id: 'cg15-xilufei-exit' },
    ],
    next: {
      cases: [
        { when: { type: 'flag', key: 'org3RecognizesOldGroup' }, next: 'r3-09h-old-group-echo' },
        { when: { type: 'flag', key: 'org3InBothGroups' }, next: 'r3-09i-both-groups-echo' },
        { when: { type: 'flag', key: 'org3RecognizesNeitherGroup' }, next: 'r3-09j-neither-group-echo' },
      ],
      fallback: 'r3-09a-qifu-after-admin',
    },
  },
  {
    id: 'r3-09h-old-group-echo', chapter: 'act2', actLabel: '第二幕 · 两个4945', date: '2026-07-21',
    location: '旧4945区群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '旧群管理员名单又变了，但三组的公告副本还在。我已标明：联络入口可以留，管理权限不等于命令权。',
    background: 'twoGroups', historical: 'fictional', next: 'r3-09a-qifu-after-admin',
  },
  {
    id: 'r3-09i-both-groups-echo', chapter: 'act2', actLabel: '第二幕 · 两个4945', date: '2026-07-21',
    location: '两个4945群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '两边都在说自己是唯一官方。我把交叉核验表挂到三组顶部：两边不一致时，只认当事人和组织群原话。',
    background: 'twoGroups', historical: 'fictional', next: 'r3-09a-qifu-after-admin',
  },
  {
    id: 'r3-09j-neither-group-echo', chapter: 'act2', actLabel: '第二幕 · 两个4945', date: '2026-07-21',
    location: '抚梅观清雪 · 组织群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '首领直联比群通知慢了十七分钟，但没有一条命令借用了“官方群”的名字。代价和好处我都写进今天记录。',
    background: 'twoGroups', historical: 'fictional', next: 'r3-09a-qifu-after-admin',
  },
  {
    id: 'r3-09a-qifu-after-admin',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-21',
    location: '祈福 · 私聊',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '我的管理已经没了。你要转发就转发这句，别替我补一个“被迫害”的理由。两个群的管理员名单，我会重新核对。',
    background: 'twoGroups',
    sound: 'message',
    historical: 'adapted',
    choices: [
      {
        id: 'respect-qifu-accountability',
        label: '把原话完整转发：“理由由你自己说明，我不替你添。”',
        tone: 'warm',
        effects: [
          { type: 'flag', key: 'qifuAccountabilityRespected' },
          { type: 'relationship', character: 'qifu', key: 'trust', value: 1 },
          { type: 'relationship', character: 'qifu', key: 'affinity', value: 1 },
          { type: 'relationshipProgress', character: 'qifu', value: 40 },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
        ],
        next: 'r3-09b-qifu-accountability-reply',
      },
      {
        id: 'keep-qifu-business-only',
        label: '“收到。名单核完发我，我们只谈公事。”',
        tone: 'calm',
        effects: [{ type: 'relationship', character: 'qifu', key: 'trust', value: 1 }, { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 }],
        next: 'r3-09c-qifu-business-reply',
      },
    ],
  },
  {
    id: 'r3-09b-qifu-accountability-reply',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-21',
    location: '祈福 · 私聊',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '收到。原话我自己背，不让你替我洗白。名单核完，我只把想说给你的那句留在私聊。',
    background: 'twoGroups',
    sound: 'message',
    historical: 'fictional',
    next: 'r3-09d-qifu-position-router',
  },
  {
    id: 'r3-09c-qifu-business-reply',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-21',
    location: '祈福 · 私聊',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '收到，只谈名单。核完以后我把变更记录发你，其余的话今晚不占你的私聊。',
    background: 'twoGroups',
    sound: 'message',
    historical: 'fictional',
    next: 'r3-09d-qifu-position-router',
  },
  {
    id: 'r3-09d-qifu-position-router', chapter: 'act2', actLabel: '第二幕 · 两个4945', date: '2026-07-21',
    location: '祈福私聊', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '区群的账我说完了，现在说三组那份立场。',
    background: 'nightMessage', historical: 'fictional',
    next: {
      cases: [
        { when: { type: 'flag', key: 'privateTalkWithQifu' }, next: 'r3-09e-private-position-echo' },
        { when: { type: 'flag', key: 'org3JoinedOrg1Pressure' }, next: 'r3-09f-joint-position-echo' },
        { when: { type: 'flag', key: 'org3IndependentStatement' }, next: 'r3-09g-independent-position-echo' },
      ],
      fallback: 'r3-10-midnight-heartbeat',
    },
  },
  {
    id: 'r3-09e-private-position-echo', chapter: 'act2', actLabel: '第二幕 · 两个4945', date: '2026-07-21',
    location: '祈福私聊', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '我没把你那句话贴到公屏。你愿意私下提醒我，我就在私下承认这次判断错了；下一次给权限前，先核人。',
    background: 'nightMessage', historical: 'fictional', next: 'r3-10-midnight-heartbeat',
  },
  {
    id: 'r3-09f-joint-position-echo', chapter: 'act2', actLabel: '第二幕 · 两个4945', date: '2026-07-21',
    location: '祈福私聊', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '联合声明压出去了，三组的签名还在。现在我的管理员出了事，别等别人替你解释为什么当时愿意和一组并排。',
    background: 'nightMessage', historical: 'fictional', next: 'r3-10-midnight-heartbeat',
  },
  {
    id: 'r3-09g-independent-position-echo', chapter: 'act2', actLabel: '第二幕 · 两个4945', date: '2026-07-21',
    location: '祈福私聊', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '三组的独立说法和一组声明还并排在那里。今天看来，立场不同不等于互相拆台；至少你没把我的名字当成证据。',
    background: 'nightMessage', historical: 'fictional', next: 'r3-10-midnight-heartbeat',
  },
  {
    id: 'r3-10-midnight-heartbeat',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-21',
    title: '扩张派的停顿',
    location: '私聊',
    mode: 'chat',
    speaker: 'heartbeat',
    portrait: 'heartbeat',
    text: '今天有人被踢出群，有人丢了管理员，三组什么都没丢。可我发现你算的不是“我们能拿什么”，而是“拿回来以后怎么放”。这点挺麻烦，也挺好。',
    background: 'nightMessage',
    choices: [
      {
        id: 'share-ambition',
        label: '“你负责看见机会，我负责让机会能留下。”',
        tone: 'warm',
        effects: [
          { type: 'relationship', character: 'heartbeat', key: 'trust', value: 2 },
          { type: 'relationship', character: 'heartbeat', key: 'affinity', value: 2 },
          { type: 'relationshipProgress', character: 'heartbeat', value: 25 },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
        ],
        next: 'r3-11-jiangjinjiu-arrives',
      },
      {
        id: 'challenge-ambition',
        label: '“别把每次离组都当成我们的招募广告。”',
        tone: 'bold',
        effects: [
          { type: 'relationship', character: 'heartbeat', key: 'trust', value: 1 },
          { type: 'relationship', character: 'heartbeat', key: 'affinity', value: 1 },
          { type: 'relationshipProgress', character: 'heartbeat', value: 15 },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
        ],
        next: 'r3-11-jiangjinjiu-arrives',
      },
    ],
  },
  {
    id: 'r3-11-jiangjinjiu-arrives',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-23',
    title: '从四组来的第二张申请',
    location: '成员申请',
    mode: 'chat',
    speaker: 'jiangjinjiu',
    portrait: 'jiangjinjiu',
    text: '我替二组说话后，和玄末吵起来，现在准备离开四组。具体聊天记录你可以去核对。三组要是只想拿我做招募截图，这份申请就当没发过。',
    background: 'warRoom',
    historical: 'adapted',
    // A full-size applicant establishes Jiangjinjiu before the following evidence review.
    presentation: {
      ui: 'classic', transition: 'crossfade', camera: 'push-in', atmosphere: 'paper',
      sprites: [{ character: 'jiangjinjiu', expression: 'neutral', pose: 'thinking', position: 'left', scale: .98 }],
    },
    choices: [
      {
        id: 'accept-without-testimony',
        label: '“可以进三组，不用拿四组当投名状。”',
        tone: 'warm',
        effects: [
          { type: 'flag', key: 'jiangjinjiuJoinedOrg3' },
          { type: 'relationship', character: 'jiangjinjiu', key: 'trust', value: 2 },
          { type: 'stat', key: 'cohesion', value: 1 },
        ],
        next: 'r3-11a-transfer-boundary',
      },
      {
        id: 'ask-for-four-intel',
        label: '“先把四组的出勤和联盟安排说清。”',
        tone: 'secret',
        effects: [
          { type: 'flag', key: 'jiangjinjiuJoinedOrg3' },
          { type: 'stat', key: 'evidence', value: 1 },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'relationship', character: 'jiangjinjiu', key: 'trust', value: -1 },
        ],
        next: 'r3-11a-transfer-boundary',
      },
      {
        id: 'decline-sensitive-transfer',
        label: '“冷却期过后再来，我不接争执中的申请。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'declinedJiangjinjiu' },
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'relationship', character: 'truth', key: 'trust', value: 1 },
        ],
        next: 'r3-11b-transfer-declined',
      },
    ],
  },
  {
    id: 'r3-11a-transfer-boundary',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-23',
    location: '抚梅观清雪 · 管理群',
    mode: 'chat',
    speaker: 'truth',
    portrait: 'truth',
    text: '将进酒替二组说话、与玄末争执、随后离四这三件事能对上。具体说了什么，现有记录不够。申请先通过，你刚才答应的边界我会一字不差地写进备注。',
    background: 'warRoom',
    historical: 'adapted',
    presentation: {
      ui: 'classic', transition: 'crossfade', camera: 'hold', atmosphere: 'paper',
      sprites: [
        { character: 'truth', expression: 'neutral', pose: 'thinking', position: 'left', scale: .92 },
        { character: 'jiangjinjiu', expression: 'neutral', pose: 'thinking', position: 'right', scale: .9, dimmed: true },
      ],
    },
    next: 'r3-12-alliance-boundary',
  },
  {
    // 拒绝转组是真正的未录取分支，不再借用“已答应边界”的通过文案。
    id: 'r3-11b-transfer-declined',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-23',
    location: '抚梅观清雪 · 管理群',
    mode: 'chat',
    speaker: 'truth',
    portrait: 'truth',
    text: '我把这次申请关闭了，三组名单没有加人。冷却期过后他可以重新申请；到时我们只核对记录，不拿今天的争执当投名状。',
    background: 'warRoom',
    historical: 'fictional',
    presentation: {
      ui: 'classic', transition: 'crossfade', camera: 'hold', atmosphere: 'paper',
      sprites: [{ character: 'truth', expression: 'neutral', pose: 'thinking', position: 'left', scale: .92 }],
    },
    next: 'r3-12-alliance-boundary',
  },
  {
    id: 'r3-12-alliance-boundary',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-24',
    location: '三四组首领群',
    mode: 'novel',
    speaker: 'yanqiu',
    portrait: 'yanqiu',
    text: '可以共同给二组压力，但积分还是各算各的。我们要公开联盟、秘密协调，还是只互不攻击？',
    background: 'warRoom',
    choices: [
      {
        id: 'public-alliance',
        label: '“公开联盟，目标和退出条件一起写。”',
        tone: 'bold',
        effects: [
          { type: 'flag', key: 'org3Org4PublicAlliance' },
          { type: 'organizationRelation', organization: 'org4', value: 2 },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'relationship', character: 'yanqiu', key: 'trust', value: 1 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 2 },
        ],
        next: 'r3-12a-public-alliance-reply',
      },
      {
        id: 'secret-coordination',
        label: '“只在首领群对目标，不发联盟公告。”',
        tone: 'secret',
        effects: [
          { type: 'flag', key: 'org3Org4SecretCoordination' },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'organizationRelation', organization: 'org4', value: 1 },
          { type: 'butterflyDelta', key: 'bf_shadow', delta: 1 },
        ],
        next: 'r3-12b-secret-alliance-reply',
      },
      {
        id: 'non-aggression-only',
        label: '“只签互不攻击，三组不替任何人冲点。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'org3Org4NonAggression' },
          { type: 'organizationRelation', organization: 'org4', value: 1 },
          { type: 'relationship', character: 'truth', key: 'trust', value: 1 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'r3-12c-nonaggression-reply',
      },
    ],
  },
  {
    id: 'r3-12a-public-alliance-reply', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-24',
    location: '三四组首领群', mode: 'chat', speaker: 'yanqiu', portrait: 'yanqiu',
    text: '那就公开。目标、积分各算、临时换标和退出条件一起发；别只把“联盟”两个字留给世界频道。',
    background: 'warRoom', historical: 'fictional', next: 'r3-13-gaobai-request',
  },
  {
    id: 'r3-12b-secret-alliance-reply', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-24',
    location: '三四组首领群', mode: 'chat', speaker: 'yanqiu', portrait: 'yanqiu',
    text: '只在首领群对目标，公告不写“盟友”。谁迟到、谁临时改门，先回自己组织解释，不用默契当免责。',
    background: 'warRoom', historical: 'fictional', next: 'r3-13-gaobai-request',
  },
  {
    id: 'r3-12c-nonaggression-reply', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-24',
    location: '三四组首领群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '我只写“互不攻击”，不写支援和共享战果。三组不替四组冲点，四组也不用自己的出勤补我们的分。',
    background: 'warRoom', historical: 'fictional', next: 'r3-13-gaobai-request',
  },
  {
    id: 'r3-13-gaobai-request',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-24',
    title: '火2战书',
    location: '跨组织私聊',
    mode: 'chat',
    speaker: 'gaobai',
    portrait: 'gaobai',
    text: '二组拒绝让那名成员来道歉。那就火2见。五组主攻，三组既然也被辰逸点名，就给我一句准话：牵制、拿自己的目标，还是站在外面看？',
    background: 'warRoom',
    historical: 'adapted',
    presentation: {
      ui: 'classic', transition: 'slide', camera: 'push-in', atmosphere: 'embers',
      sprites: [{ character: 'gaobai', expression: 'neutral', pose: 'command', position: 'right' }],
    },
    choices: [
      {
        id: 'support-five',
        label: '“给你出勤表和目标线，三组帮你牵制。”',
        tone: 'bold',
        effects: [
          { type: 'flag', key: 'org3SupportedOrg5AtFireTwo' },
          { type: 'organizationRelation', organization: 'org5', value: 1 },
          { type: 'stat', key: 'resources', value: -1 },
          { type: 'relationshipProgress', character: 'heartbeat', value: 10 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
        ],
        next: 'r3-13b-support-five-reply',
      },
      {
        id: 'seize-own-target',
        label: '“你打火2，我们去拿自己的点。”',
        tone: 'secret',
        effects: [
          { type: 'flag', key: 'org3SeizedOwnFortress' },
          { type: 'stat', key: 'resources', value: 2 },
          { type: 'organizationRelation', organization: 'org5', value: -1 },
          { type: 'relationship', character: 'heartbeat', key: 'trust', value: 1 },
          { type: 'relationshipProgress', character: 'heartbeat', value: 15 },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
        ],
        next: 'r3-13c-own-target-reply',
      },
      {
        id: 'offer-neutral-mediation',
        label: '“三组不下场；开战前我可以再传一次话。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'org3StayedNeutralAtFireTwo' },
          { type: 'stat', key: 'reputation', value: -1 },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'relationshipProgress', character: 'heartbeat', value: 5 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'r3-13d-neutral-mediation-reply',
      },
    ],
  },
  {
    id: 'r3-13b-support-five-reply', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-24',
    location: '五组 · 战备语音', mode: 'chat', speaker: 'gaobai', portrait: 'gaobai',
    text: '出勤表和目标线发我。三组牵制哪个门我会写进五组战备，但结算仍然各算各的，别到时候互相借分。',
    background: 'warRoom', historical: 'fictional', next: 'r3-13a-gaobai-war-room',
  },
  {
    id: 'r3-13c-own-target-reply', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-24',
    location: '五组 · 战备语音', mode: 'chat', speaker: 'gaobai', portrait: 'gaobai',
    text: '可以，你们拿自己的点，我们打火2。战报里别把“同时开打”写成“一起参战”，五组输赢不让三组陪签。',
    background: 'warRoom', historical: 'fictional', next: 'r3-13a-gaobai-war-room',
  },
  {
    id: 'r3-13d-neutral-mediation-reply', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-24',
    location: '跨组织私聊', mode: 'chat', speaker: 'gaobai', portrait: 'gaobai',
    text: '你可以再传一次话，但七点五十以后我只看上线名单。三组不下场我会写清楚，别把中立说成你能保证任何一边停手。',
    background: 'warRoom', historical: 'fictional', next: 'r3-13a-gaobai-war-room',
  },
  {
    id: 'r3-13a-gaobai-war-room',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-24',
    location: '五组 · 战备语音',
    mode: 'chat',
    speaker: 'gaobai',
    portrait: 'gaobai',
    text: '我的主队表已经发了，七点五十还没进语音的人直接换掉。你们参不参战由你定，但别到八点再问我火2在哪。',
    background: 'warRoom',
    sound: 'message',
    historical: 'fictional',
    next: 'r3-12d-alliance-echo-router',
  },
  {
    id: 'r3-12d-alliance-echo-router', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-24',
    location: '三四组首领群', mode: 'chat', speaker: 'yanqiu', portrait: 'yanqiu',
    text: '五组的战备表到了，现在按我们写下的关系处理。',
    background: 'warRoom', historical: 'fictional',
    next: {
      cases: [
        { when: { type: 'flag', key: 'org3Org4PublicAlliance' }, next: 'r3-12e-public-alliance-echo' },
        { when: { type: 'flag', key: 'org3Org4SecretCoordination' }, next: 'r3-12f-secret-alliance-echo' },
        { when: { type: 'flag', key: 'org3Org4NonAggression' }, next: 'r3-12g-nonaggression-echo' },
      ],
      fallback: 'r3-13e-war-role-router',
    },
  },
  {
    id: 'r3-12e-public-alliance-echo', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-24',
    location: '三四组联盟公告', mode: 'chat', speaker: 'yanqiu', portrait: 'yanqiu',
    text: '公开联盟的目标和退出条件都贴好了。火2时间表也让所有人看见，让路靠记录，不靠事后说“我以为”。',
    background: 'warRoom', historical: 'fictional', next: 'r3-13e-war-role-router',
  },
  {
    id: 'r3-12f-secret-alliance-echo', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-24',
    location: '三四组首领群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '两组目标已经对过，没有公告。迟到和临时改标都会留在这个群里，不能因为外面不知道就当成没发生。',
    background: 'warRoom', historical: 'fictional', next: 'r3-13e-war-role-router',
  },
  {
    id: 'r3-12g-nonaggression-echo', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-24',
    location: '三四组首领群', mode: 'chat', speaker: 'yanqiu', portrait: 'yanqiu',
    text: '三、四组不冲同一个门，其他安排各自负责。五组求援时，这份协议不会自动把任何人变成支援。',
    background: 'warRoom', historical: 'fictional', next: 'r3-13e-war-role-router',
  },
  {
    id: 'r3-13e-war-role-router', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-24',
    location: '三组 · 战备语音', mode: 'chat', speaker: 'heartbeat', portrait: 'heartbeat',
    text: '盟友边界对完了，再确认三组自己在火2的位置。',
    background: 'warRoom', historical: 'fictional',
    next: {
      cases: [
        { when: { type: 'flag', key: 'org3SupportedOrg5AtFireTwo' }, next: 'r3-13f-support-role-echo' },
        { when: { type: 'flag', key: 'org3SeizedOwnFortress' }, next: 'r3-13g-own-target-echo' },
        { when: { type: 'flag', key: 'org3StayedNeutralAtFireTwo' }, next: 'r3-13h-neutral-role-echo' },
      ],
      fallback: 'r3-14-fortress-opens',
    },
  },
  {
    id: 'r3-13f-support-role-echo', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-24',
    location: '三组 · 战备语音', mode: 'chat', speaker: 'heartbeat', portrait: 'heartbeat',
    text: '五组已经收到我们的出勤和牵制目标。三组会出现在战场上，但谁拿分、谁败报都分开写。',
    background: 'warRoom', historical: 'fictional', next: 'r3-14-fortress-opens',
  },
  {
    id: 'r3-13g-own-target-echo', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-24',
    location: '三组 · 战备语音', mode: 'chat', speaker: 'heartbeat', portrait: 'heartbeat',
    text: '我们的目标和火2分开标了。结算时只报三组拿到的分，不拿五组的战报来补我们的参与感。',
    background: 'warRoom', historical: 'fictional', next: 'r3-14-fortress-opens',
  },
  {
    id: 'r3-13h-neutral-role-echo', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-24',
    location: '三组 · 战备语音', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '停手传话已经发过，没有人撤战书。三组不下场，这是边界，不是我们保证两边不会开打。',
    background: 'warRoom', historical: 'fictional', next: 'r3-14-fortress-opens',
  },
  {
    id: 'r3-14-fortress-opens',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-25',
    title: '第二次要塞',
    location: '要塞争夺战',
    mode: 'battle',
    speaker: 'system',
    text: '五组向二组火2发起挑战。三组与四组的积分独立结算；你们能共享的是目标和情报，不能共享系统分数。',
    background: 'fortress',
    music: 'fortressNight',
    historical: 'confirmed',
    presentation: {
      cg: cgPath('cg29-second-fortress'),
      cgAlt: '三组从协同战线看见夏娜指挥江南分兵守卫火2，联盟目标重合但积分各自结算',
      ui: 'classic',
      transition: 'flash',
      camera: 'push-in',
      atmosphere: 'embers',
      focus: 'left',
    },
    onEnter: [{ type: 'unlockCg', id: 'cg29-second-fortress' }],
    choices: [
      {
        id: 'honor-plan',
        label: '按战前表进点，不临时换目标',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'org3HonoredFortressPlan' },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'relationshipProgress', character: 'heartbeat', value: 15 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
        ],
        next: 'r3-14b-honor-plan-reply',
      },
      {
        id: 'change-for-profit',
        label: '临时换标：“先拿三组自己的分。”',
        tone: 'danger',
        effects: [
          { type: 'flag', key: 'org3ChangedFortressPlan' },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'organizationRelation', organization: 'org4', value: -1 },
          { type: 'organizationRelation', organization: 'org5', value: -1 },
          { type: 'relationshipProgress', character: 'heartbeat', value: 5 },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
        ],
        next: 'r3-14c-change-plan-reply',
      },
    ],
  },
  {
    id: 'r3-14b-honor-plan-reply', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-25',
    location: '三组 · 要塞语音', mode: 'chat', speaker: 'heartbeat', portrait: 'heartbeat',
    text: '按表走。我把三组坐标发给四、五组，让他们知道我们不会在倒计时里突然换门。',
    background: 'fortress', sound: 'warning', historical: 'fictional', next: 'r3-14a-live-call',
  },
  {
    id: 'r3-14c-change-plan-reply', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-25',
    location: '三组 · 要塞语音', mode: 'chat', speaker: 'heartbeat', portrait: 'heartbeat',
    text: '临时换标我记下了。先拿三组的分可以，但别在战报里写成我们从来没答应过别人。',
    background: 'fortress', sound: 'warning', historical: 'fictional', next: 'r3-14a-live-call',
  },
  {
    id: 'r3-14a-live-call',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-25',
    location: '三组 · 要塞语音',
    mode: 'chat',
    speaker: 'heartbeat',
    portrait: 'heartbeat',
    text: '告白已经带五组进火2了。三组频道只报自己的坐标和人数；能协调目标，不等于系统会把我们的分数加在一起。',
    background: 'fortress',
    sound: 'warning',
    historical: 'fictional',
    next: {
      cases: [
        { when: { type: 'flag', key: 'org3HonoredFortressPlan' }, next: 'r3-14d-honor-result-echo' },
        { when: { type: 'flag', key: 'org3ChangedFortressPlan' }, next: 'r3-14e-change-result-echo' },
      ],
      fallback: 'r3-15-fortress-result',
    },
  },
  {
    id: 'r3-14d-honor-result-echo', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-25',
    location: '三组 · 要塞语音', mode: 'chat', speaker: 'heartbeat', portrait: 'heartbeat',
    text: '四组坐标和五组牵制线都按表保留了。三组的出勤会写进自己的战报，不管火2结果怎么跳。',
    background: 'fortress', historical: 'fictional', next: 'r3-15-fortress-result',
  },
  {
    id: 'r3-14e-change-result-echo', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-25',
    location: '三组 · 要塞语音', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '我们改了目标，资源分已经到账。五组仍然会按固定战果结算火2，但三组与他们的关系代价不能从战报删掉。',
    background: 'fortress', historical: 'fictional', next: 'r3-15-fortress-result',
  },
  {
    id: 'r3-15-fortress-result',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-25',
    location: '战果结算',
    mode: 'system',
    speaker: 'system',
    text: '倒计时归零。二组守住火2，五组挑战失败。三组的积分单独结束计算，战备群里随即弹出两条新的好友申请。',
    background: 'aftermath',
    historical: 'confirmed',
    onEnter: [
      { type: 'flag', key: 'org2WonFireTwo' },
      { type: 'flag', key: 'org5LostFireTwo' },
    ],
    next: 'r3-16a-oguri-gaobai-arrive',
  },
  {
    id: 'r3-16a-oguri-gaobai-arrive',
    chapter: 'act4',
    actLabel: '第四幕 · 胜利以后怎么分',
    date: '2026-07-26',
    title: '两条转组通知',
    location: '抚梅观清雪 · 成员申请',
    mode: 'chat',
    speaker: 'oguri',
    portrait: 'oguri',
    text: '我是OguriC（小栗帽）。7月26日，我和告白都已经进三组。我不要一句“以后看情况”；把今晚的出勤表、我负责的队和可以动的权限发给我。',
    background: 'aftermath',
    sound: 'notice',
    historical: 'confirmed',
    next: 'r3-16-merger-offer',
  },
  {
    id: 'r3-16-merger-offer',
    chapter: 'act4',
    actLabel: '第四幕 · 胜利以后怎么分',
    date: '2026-07-26',
    title: '合并不是删除键',
    location: '三五组谈判',
    mode: 'novel',
    speaker: 'wenxian',
    portrait: 'wenxian',
    text: 'OguriC和告白已经转进三组，五组依然还在。我可以谈剩下成员的去向，也可以谈平等合作。别把“合并”写成删除键；留在五组的人明天还要上线。',
    background: 'aftermath',
    presentation: {
      ui: 'classic', transition: 'crossfade', camera: 'push-in', atmosphere: 'dust',
      sprites: [{ character: 'wenxian', expression: 'concerned', pose: 'thinking', position: 'left', scale: 1.02 }],
    },
    choices: [
      {
        id: 'absorb-whole-org',
        label: '“五组建制并进来，普通成员位置全部保留。”',
        tone: 'bold',
        effects: [
          { type: 'flag', key: 'org3AbsorbedMostOfOrg5' },
          { type: 'stat', key: 'resources', value: 2 },
          { type: 'stat', key: 'cohesion', value: -2 },
          { type: 'relationship', character: 'wenxian', key: 'trust', value: 1 },
          { type: 'relationship', character: 'truth', key: 'trust', value: -1 },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
        ],
        next: 'r3-16b-absorb-reply',
      },
      {
        id: 'recruit-core',
        label: '“只接愿意转来的核心，五组保留建制。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'org5PartiallyAbsorbed' },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'stat', key: 'reputation', value: -1 },
          { type: 'relationship', character: 'oguri', key: 'trust', value: 1 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'r3-16c-recruit-reply',
      },
      {
        id: 'equal-alliance',
        label: '“人已经进来，五组仍按平等盟友重建。”',
        tone: 'warm',
        effects: [
          { type: 'flag', key: 'org3Org5EqualAlliance' },
          { type: 'organizationRelation', organization: 'org5', value: 2 },
          { type: 'stat', key: 'reputation', value: 2 },
          { type: 'relationship', character: 'wenxian', key: 'trust', value: 2 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'r3-16d-equal-reply',
      },
      {
        id: 'refuse-absorption',
        label: '“到此为止，不再趁战败继续挖人。”',
        tone: 'secret',
        effects: [
          { type: 'flag', key: 'org3RefusedAbsorption' },
          { type: 'stat', key: 'reputation', value: 2 },
          { type: 'stat', key: 'resources', value: -1 },
          { type: 'relationship', character: 'truth', key: 'trust', value: 2 },
          { type: 'relationship', character: 'heartbeat', key: 'trust', value: -1 },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
        ],
        next: 'r3-16e-refuse-reply',
      },
    ],
  },
  {
    id: 'r3-16b-absorb-reply', chapter: 'act4', actLabel: '第四幕 · 胜利以后怎么分', date: '2026-07-26',
    location: '三五组谈判', mode: 'chat', speaker: 'wenxian', portrait: 'wenxian',
    text: '建制并进来可以，普通席位我会替他们保留。但五组原来的权限不会自动复制，谁负责、谁复核，要重新写进三组的表。',
    background: 'aftermath', historical: 'fictional', next: 'r3-17-management-seats',
  },
  {
    id: 'r3-16c-recruit-reply', chapter: 'act4', actLabel: '第四幕 · 胜利以后怎么分', date: '2026-07-26',
    location: '三五组谈判', mode: 'chat', speaker: 'oguri', portrait: 'oguri',
    text: '那就只接愿意转的人。我和告白先把三组的活做起来，五组的门牌和剩下名单不清零。',
    background: 'aftermath', historical: 'fictional', next: 'r3-17-management-seats',
  },
  {
    id: 'r3-16d-equal-reply', chapter: 'act4', actLabel: '第四幕 · 胜利以后怎么分', date: '2026-07-26',
    location: '三五组谈判', mode: 'chat', speaker: 'wenxian', portrait: 'wenxian',
    text: '五组保留门牌，三、五组共享战报，责任各算。平等不是不写负责人，是不拿战败把另一边改成附属。',
    background: 'aftermath', historical: 'fictional', next: 'r3-17-management-seats',
  },
  {
    id: 'r3-16e-refuse-reply', chapter: 'act4', actLabel: '第四幕 · 胜利以后怎么分', date: '2026-07-26',
    location: '三五组谈判', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '到这里停。我们不把五组战败当成招募窗口；他们继续上线，三组也承担少拿人的代价。',
    background: 'aftermath', historical: 'fictional', next: 'r3-17a-oguri-delivers',
  },
  {
    id: 'r3-17-management-seats',
    chapter: 'act4',
    actLabel: '第四幕 · 胜利以后怎么分',
    date: '2026-07-27',
    title: '两个高层位置',
    location: '组织管理',
    mode: 'novel',
    speaker: 'truth',
    portrait: 'truth',
    text: '人已经进来，但正式高层仍然只有两个位置。心跳能拉人，OguriC能执行，我负责把承诺和证据对上。谁拿权限，你现在点名。',
    background: 'rewardHall',
    // Two restrained figures keep faces above mobile choices while making the contested seats visible.
    presentation: {
      ui: 'classic', transition: 'crossfade', camera: 'pull-back', atmosphere: 'paper',
      sprites: [
        { character: 'truth', expression: 'neutral', pose: 'thinking', position: 'left', scale: .9 },
        { character: 'oguri', expression: 'neutral', pose: 'command', position: 'right', scale: .9 },
      ],
    },
    choices: [
      {
        id: 'truth-oguri',
        label: '把权限交给真理与OguriC：“心跳继续负责拉人。”',
        tone: 'calm',
        effects: [
          { type: 'highCouncil', members: ['truth', 'oguri'] },
          { type: 'flag', key: 'appointedTruthAndOguri' },
          { type: 'relationship', character: 'truth', key: 'trust', value: 1 },
          { type: 'relationship', character: 'oguri', key: 'trust', value: 2 },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'r3-17a-oguri-delivers',
      },
      {
        id: 'heartbeat-truth',
        label: '“心跳和真理留任；OguriC先负责执行。”',
        tone: 'warm',
        effects: [
          { type: 'highCouncil', members: ['heartbeat', 'truth'] },
          { type: 'relationship', character: 'heartbeat', key: 'trust', value: 1 },
          { type: 'relationshipProgress', character: 'heartbeat', value: 25 },
          { type: 'relationship', character: 'oguri', key: 'trust', value: -1 },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
        ],
        next: 'r3-17a-oguri-delivers',
      },
      {
        id: 'heartbeat-oguri',
        label: '“心跳和OguriC进管理组。”',
        tone: 'danger',
        effects: [
          { type: 'highCouncil', members: ['heartbeat', 'oguri'] },
          { type: 'relationship', character: 'heartbeat', key: 'trust', value: 2 },
          { type: 'relationshipProgress', character: 'heartbeat', value: 30 },
          { type: 'relationship', character: 'oguri', key: 'trust', value: 2 },
          { type: 'relationship', character: 'truth', key: 'trust', value: -2 },
          { type: 'stance', character: 'truth', value: 'oppose' },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
        ],
        next: 'r3-17a-oguri-delivers',
      },
    ],
  },
  {
    id: 'r3-17a-oguri-delivers',
    chapter: 'act4',
    actLabel: '第四幕 · 胜利以后怎么分',
    date: '2026-07-27',
    location: '抚梅观清雪 · 出勤频道',
    mode: 'chat',
    speaker: 'oguri',
    portrait: 'oguri',
    text: '今晚两队名单、替补顺序和活动冷却我都对完了。有没有高层头衔不影响我做这份表；但你们答应新成员的事，明天要能在表里找到。',
    background: 'rewardHall',
    sound: 'message',
    historical: 'fictional',
    // Old saves without a merger flag keep the original continuation.
    next: {
      cases: [
        { when: { type: 'flag', key: 'org3AbsorbedMostOfOrg5' }, next: 'r3-17b-absorb-echo' },
        { when: { type: 'flag', key: 'org5PartiallyAbsorbed' }, next: 'r3-17c-recruit-echo' },
        { when: { type: 'flag', key: 'org3Org5EqualAlliance' }, next: 'r3-17d-equal-echo' },
        { when: { type: 'flag', key: 'org3RefusedAbsorption' }, next: 'r3-17e-refuse-echo' },
      ],
      fallback: 'r3-18-other-reorganizations',
    },
  },
  {
    id: 'r3-17b-absorb-echo', chapter: 'act4', actLabel: '第四幕 · 胜利以后怎么分', date: '2026-07-27',
    location: '抚梅观清雪 · 出勤频道', mode: 'chat', speaker: 'oguri', portrait: 'oguri',
    text: '五组建制名单已经并进来，明天先处理一张表的拥堵。席位保留不等于权限复制，我把每个复核人单列。',
    background: 'rewardHall', historical: 'fictional', next: 'r3-18-other-reorganizations',
  },
  {
    id: 'r3-17c-recruit-echo', chapter: 'act4', actLabel: '第四幕 · 胜利以后怎么分', date: '2026-07-27',
    location: '抚梅观清雪 · 出勤频道', mode: 'chat', speaker: 'oguri', portrait: 'oguri',
    text: '转来的核心先试运行，五组名单没有清零。能动哪些权限、由谁复核，我都在表里另开了一栏。',
    background: 'rewardHall', historical: 'fictional', next: 'r3-18-other-reorganizations',
  },
  {
    id: 'r3-17d-equal-echo', chapter: 'act4', actLabel: '第四幕 · 胜利以后怎么分', date: '2026-07-27',
    location: '三五组联络群', mode: 'chat', speaker: 'wenxian', portrait: 'wenxian',
    text: '五组门牌还在，今晚战报与三组共享。谁迟到、谁改标仍记在各自名下，这才是你说的平等。',
    background: 'rewardHall', historical: 'fictional', next: 'r3-18-other-reorganizations',
  },
  {
    id: 'r3-17e-refuse-echo', chapter: 'act4', actLabel: '第四幕 · 胜利以后怎么分', date: '2026-07-27',
    location: '抚梅观清雪 · 出勤频道', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '五组继续在线，三组没有再发转组邀请。名单短了一截，这是我们选择不趁战败挖人的实际代价。',
    background: 'rewardHall', historical: 'fictional', next: 'r3-18-other-reorganizations',
  },
  {
    id: 'r3-18-other-reorganizations',
    chapter: 'act4',
    actLabel: '第四幕 · 胜利以后怎么分',
    date: '2026-07-27',
    location: '区服简报',
    mode: 'system',
    speaker: 'system',
    text: '四组的追击晓组织饰品分配引发争执：takemehand与砚秋水吵了起来，砚秋水退出，华月乌大王接任。六组也传来交接消息，但具体次序还没有对齐。',
    background: 'rewardHall',
    historical: 'adapted',
    onEnter: [
      { type: 'flag', key: 'yanqiuLeftOrg4' },
      { type: 'flag', key: 'huayueBecameOrg4Leader' },
    ],
    next: 'r3-19-gaobai-leaves',
  },
  {
    id: 'r3-19-gaobai-leaves',
    chapter: 'act4',
    actLabel: '第四幕 · 胜利以后怎么分',
    date: '2026-07-28',
    title: '两天后的申请',
    location: '三组成员列表',
    mode: 'chat',
    speaker: 'gaobai',
    portrait: 'gaobai',
    text: '我去一组。具体原因我不写，你也别替我写。今晚的出勤我会交接完，然后你把名单更新掉。',
    background: 'nightMessage',
    historical: 'adapted',
    presentation: {
      ui: 'classic', transition: 'crossfade', camera: 'pull-back', atmosphere: 'rain',
      sprites: [{ character: 'gaobai', expression: 'neutral', pose: 'relaxed', position: 'center', scale: .98 }],
    },
    choices: [
      {
        id: 'release-transparently',
        label: '“公告只写：告白自愿转入一组。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'gaobaiLeftForOrg1' },
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'relationship', character: 'truth', key: 'trust', value: 1 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'r3-19a-gaobai-transfer',
      },
      {
        id: 'offer-position-to-stay',
        label: '“最后问一次：换职责，你会不会留下？”',
        tone: 'warm',
        effects: [
          { type: 'flag', key: 'gaobaiDepartureDelayed' },
          { type: 'stat', key: 'resources', value: -1 },
          { type: 'stat', key: 'cohesion', value: -1 },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
        ],
        next: 'r3-19a-gaobai-transfer',
      },
      {
        id: 'frame-as-betrayal',
        label: '在公告里写下：“告白背叛三组。”',
        tone: 'danger',
        effects: [
          { type: 'flag', key: 'gaobaiLeftForOrg1' },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'stat', key: 'reputation', value: -2 },
          { type: 'relationship', character: 'oguri', key: 'trust', value: -2 },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 2 },
        ],
        next: 'r3-19a-gaobai-transfer',
      },
    ],
  },
  {
    id: 'r3-19a-gaobai-transfer',
    chapter: 'act4',
    actLabel: '第四幕 · 胜利以后怎么分',
    date: '2026-07-28',
    location: '抚梅观清雪 · 成员名单',
    mode: 'chat',
    speaker: 'oguri',
    portrait: 'oguri',
    text: '名单已更新：告白于7月28日离开三组，转入一组。他留下的出勤交接我接手；至于他为什么走，名单里没有这一栏。',
    background: 'nightMessage',
    sound: 'notice',
    historical: 'confirmed',
    next: 'r3-20-chenyi-offline',
  },
  {
    id: 'r3-20-chenyi-offline',
    chapter: 'epilogue',
    actLabel: '尾声 · 一天没上线',
    date: '2026-07-28',
    location: '大古 · 私聊',
    mode: 'chat',
    speaker: 'daigu',
    portrait: 'daigu',
    text: '二组那边的名单也更新了：辰逸一天没上线，本人说不想玩，7月28日按普通不活跃成员移出。没有新的冲突，也没有再开一场会。',
    background: 'nightMessage',
    music: 'afterOnline',
    historical: 'confirmed',
    presentation: {
      cg: cgPath('cg32-chenyi-leaves'),
      cgAlt: '辰逸在没有新冲突的7月28日放下普通成员令牌，因一天未上线且不想玩而离开名单',
      ui: 'cinematic',
      transition: 'crossfade',
      camera: 'pull-back',
      atmosphere: 'dust',
      focus: 'center',
    },
    onEnter: [
      { type: 'flag', key: 'chenyiRemovedOnJuly28' },
      { type: 'unlockCg', id: 'cg32-chenyi-leaves' },
    ],
    next: 'r3-20a-night-hub',
  },
  {
    id: 'r3-20a-night-hub',
    chapter: 'epilogue',
    actLabel: '尾声 · 零点后的五扇窗',
    date: '2026-07-28',
    title: '成员夜话',
    location: '抚梅观清雪 · 深夜在线列表',
    mode: 'novel',
    speaker: 'heartbeat',
    portrait: 'heartbeat',
    text: '零点过了，职位表终于安静，在线列表却亮着五个名字。心跳把它叫“加班后的符卡时间”；真理纠正说，符卡不报销夜宵。你可以敲开想听的窗口，也可以把其他话留给另一个夜晚。',
    background: 'nightMessage',
    historical: 'fictional',
    presentation: {
      ui: 'classic', transition: 'crossfade', camera: 'pull-back', atmosphere: 'messages',
      sprites: [{ character: 'heartbeat', expression: 'smile', pose: 'phone', position: 'left', scale: .96 }],
    },
    choices: [
      {
        id: 'visit-heartbeat-night',
        label: '敲开心跳的窗口：“还在数空位？”',
        tone: 'warm',
        condition: { type: 'not', condition: { type: 'flag', key: 'r3NightHeartbeatDone' } },
        next: 'r3-20b-heartbeat-night',
      },
      {
        id: 'visit-truth-night',
        label: '敲开真理的窗口：“最后一栏写什么？”',
        tone: 'calm',
        condition: { type: 'not', condition: { type: 'flag', key: 'r3NightTruthDone' } },
        next: 'r3-20c-truth-night',
      },
      {
        id: 'visit-oguri-night',
        label: '敲开OguriC的窗口：“出勤表还没睡？”',
        tone: 'calm',
        condition: { type: 'not', condition: { type: 'flag', key: 'r3NightOguriDone' } },
        next: 'r3-20d-oguri-night',
      },
      {
        id: 'visit-bottle-night',
        label: '接通顶级奶瓶：“一组的表怎么送到三组了？”',
        tone: 'secret',
        condition: { type: 'not', condition: { type: 'flag', key: 'r3NightBottleDone' } },
        next: 'r3-20e-bottle-night',
      },
      {
        id: 'visit-jiangjinjiu-night',
        label: '点开将进酒发来的白猫符纸',
        tone: 'secret',
        condition: { type: 'not', condition: { type: 'flag', key: 'r3NightJiangjinjiuDone' } },
        next: 'r3-20f-jiangjinjiu-night',
      },
      {
        id: 'release-pet-contract',
        label: '主动揭下白猫符纸：“契约到这里，恢复原样。”',
        tone: 'calm',
        condition: { type: 'flag', key: 'jiangjinjiuPetContracted' },
        effects: [{ type: 'flag', key: 'jiangjinjiuPetContracted', value: false }],
        next: 'r3-20f4-pet-released',
      },
      {
        id: 'finish-member-night',
        label: '合上夜话名单：“现在去回最后那条私聊。”',
        tone: 'warm',
        next: 'r3-21-bond-router',
      },
    ],
  },
  {
    id: 'r3-20b-heartbeat-night',
    chapter: 'epilogue',
    actLabel: '尾声 · 扩张派的算盘',
    date: '2026-07-28',
    location: '心跳成瘾 · 私聊',
    mode: 'chat',
    speaker: 'heartbeat',
    portrait: 'heartbeat',
    text: '我没数空位。我在数哪些人进来以后，第一周有人记得问他吃没吃到奖励。听起来不像扩张派？没办法，拉来十个又跑十一个，报表会对我进行精神攻击。你要陪我把回访名单写完吗？',
    background: 'nightMessage',
    historical: 'fictional',
    presentation: {
      ui: 'classic', transition: 'crossfade', camera: 'push-in', atmosphere: 'messages',
      sprites: [{ character: 'heartbeat', expression: 'soft', pose: 'phone', position: 'center', scale: 1.02 }],
    },
    choices: [
      {
        id: 'heartbeat-night-write-together',
        label: '“你问为什么来，我问为什么留下。一起写。”',
        tone: 'warm',
        effects: [
          { type: 'flag', key: 'r3NightHeartbeatDone' },
          { type: 'relationship', character: 'heartbeat', key: 'trust', value: 2 },
          { type: 'relationship', character: 'heartbeat', key: 'affinity', value: 2 },
          { type: 'relationshipProgress', character: 'heartbeat', value: 20 },
        ],
        next: 'r3-20b1-heartbeat-reply',
      },
      {
        id: 'heartbeat-night-send-template',
        label: '把回访模板发过去：“先别把关心做成抽卡。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'r3NightHeartbeatDone' },
          { type: 'relationship', character: 'heartbeat', key: 'trust', value: 1 },
          { type: 'relationshipProgress', character: 'heartbeat', value: 10 },
        ],
        next: 'r3-20b2-heartbeat-reply',
      },
    ],
  },
  {
    id: 'r3-20b1-heartbeat-reply',
    chapter: 'epilogue',
    actLabel: '尾声 · 扩张派的算盘',
    date: '2026-07-28',
    location: '心跳成瘾 · 私聊',
    mode: 'chat',
    speaker: 'heartbeat',
    portrait: 'heartbeat',
    text: '成交。第一行先写你：为什么留下——因为还有个扩张派会在凌晨把表格发错群。你不许删，这算我的招募售后。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r3-20a-night-hub',
  },
  {
    id: 'r3-20b2-heartbeat-reply',
    chapter: 'epilogue',
    actLabel: '尾声 · 扩张派的算盘',
    date: '2026-07-28',
    location: '心跳成瘾 · 私聊',
    mode: 'chat',
    speaker: 'heartbeat',
    portrait: 'heartbeat',
    text: '放心，我的抽卡只有保底：每个进来的人至少被认真问一次。模板我收了，末尾那句“别在凌晨群发”我当没看见。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r3-20a-night-hub',
  },
  {
    id: 'r3-20c-truth-night',
    chapter: 'epilogue',
    actLabel: '尾声 · 未知也要占一格',
    date: '2026-07-28',
    location: '真理 · 私聊',
    mode: 'chat',
    speaker: 'truth',
    portrait: 'truth',
    text: '最后一栏叫“尚不知道”。有人说这不像结论，我说空白才最容易被后来的人填成传说。你要在这页签字，还是给它盖一枚东方风格、但法律上毫无效力的符卡章？',
    background: 'nightMessage',
    historical: 'fictional',
    presentation: {
      ui: 'classic', transition: 'ink', camera: 'hold', atmosphere: 'paper',
      sprites: [{ character: 'truth', expression: 'neutral', pose: 'thinking', position: 'center', scale: .98 }],
    },
    choices: [
      {
        id: 'truth-night-sign-unknown',
        label: '签下名字：“不知道，也是一条诚实记录。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'r3NightTruthDone' },
          { type: 'relationship', character: 'truth', key: 'trust', value: 2 },
          { type: 'stat', key: 'evidence', value: 1 },
        ],
        next: 'r3-20c1-truth-reply',
      },
      {
        id: 'truth-night-use-spell-card',
        label: '盖下符卡章：“未确认·不许脑补。”',
        tone: 'warm',
        effects: [
          { type: 'flag', key: 'r3NightTruthDone' },
          { type: 'relationship', character: 'truth', key: 'affinity', value: 1 },
        ],
        next: 'r3-20c2-truth-reply',
      },
    ],
  },
  {
    id: 'r3-20c1-truth-reply',
    chapter: 'epilogue',
    actLabel: '尾声 · 未知也要占一格',
    date: '2026-07-28',
    location: '真理 · 私聊',
    mode: 'chat',
    speaker: 'truth',
    portrait: 'truth',
    text: '我会把签名留在版本记录里。明天若有人带来新证据，我们改结论，不改自己曾经不知道这件事。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r3-20a-night-hub',
  },
  {
    id: 'r3-20c2-truth-reply',
    chapter: 'epilogue',
    actLabel: '尾声 · 未知也要占一格',
    date: '2026-07-28',
    location: '真理 · 私聊',
    mode: 'chat',
    speaker: 'truth',
    portrait: 'truth',
    text: '章可以留下，旁边加注：“没有法力，仅对管理群的想象力生效。”这大概是今晚最严谨的一句废话。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r3-20a-night-hub',
  },
  {
    id: 'r3-20d-oguri-night',
    chapter: 'epilogue',
    actLabel: '尾声 · 名单之外的替补',
    date: '2026-07-28',
    location: 'OguriC · 私聊',
    mode: 'chat',
    speaker: 'oguri',
    portrait: 'oguri',
    text: '表睡了，我没有。新成员里有个人每次都说“随便”，然后把没人要的位置补上。我想给他固定休息日，又怕他以为自己被踢出主队。你来发消息，还是我把整张表重排？',
    background: 'nightMessage',
    historical: 'fictional',
    presentation: {
      ui: 'classic', transition: 'crossfade', camera: 'push-in', atmosphere: 'paper',
      sprites: [{ character: 'oguri', expression: 'concerned', pose: 'thinking', position: 'center', scale: .98 }],
    },
    choices: [
      {
        id: 'oguri-night-send-rest-message',
        label: '“我告诉他：休息不是掉队，是轮换的一部分。”',
        tone: 'warm',
        effects: [
          { type: 'flag', key: 'r3NightOguriDone' },
          { type: 'relationship', character: 'oguri', key: 'trust', value: 2 },
          { type: 'stat', key: 'cohesion', value: 1 },
        ],
        next: 'r3-20d1-oguri-reply',
      },
      {
        id: 'oguri-night-rewrite-roster',
        label: '把替补也写进主表：“别让愿意补位的人隐身。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'r3NightOguriDone' },
          { type: 'relationship', character: 'oguri', key: 'trust', value: 1 },
          { type: 'stat', key: 'resources', value: -1 },
        ],
        next: 'r3-20d2-oguri-reply',
      },
    ],
  },
  {
    id: 'r3-20d1-oguri-reply',
    chapter: 'epilogue',
    actLabel: '尾声 · 名单之外的替补',
    date: '2026-07-28',
    location: 'OguriC · 私聊',
    mode: 'chat',
    speaker: 'oguri',
    portrait: 'oguri',
    text: '好。你负责把人话说清，我负责让系统表格别把人话吃掉。明早八点我检查他有没有真的休息——这句话好像哪里不对。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r3-20a-night-hub',
  },
  {
    id: 'r3-20d2-oguri-reply',
    chapter: 'epilogue',
    actLabel: '尾声 · 名单之外的替补',
    date: '2026-07-28',
    location: 'OguriC · 私聊',
    mode: 'chat',
    speaker: 'oguri',
    portrait: 'oguri',
    text: '重排完了。现在每个替补都有自己的格子，代价是表宽得像要塞地图。手机用户会骂你，不会骂那个总补位的人，值得。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r3-20a-night-hub',
  },
  {
    id: 'r3-20e-bottle-night',
    chapter: 'epilogue',
    actLabel: '尾声 · 外组来客的保温杯',
    date: '2026-07-28',
    location: '顶级奶瓶 · 跨组织私聊',
    mode: 'chat',
    speaker: 'bottle',
    portrait: 'bottle',
    text: '一组的旧出勤表误传给你了，别紧张，里面最机密的内容是“周三提醒祈福别连发三遍公告”。既然看见了，你帮我选：删掉这份表，还是把空模板留给三组？',
    background: 'nightMessage',
    historical: 'fictional',
    presentation: {
      ui: 'classic', transition: 'slide', camera: 'hold', atmosphere: 'messages',
      sprites: [{ character: 'bottle', expression: 'smile', pose: 'phone', position: 'center', scale: .98 }],
    },
    choices: [
      {
        id: 'bottle-night-delete-private-data',
        label: '删掉原表：“模板可以留，成员备注不跨组。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'r3NightBottleDone' },
          { type: 'relationship', character: 'bottle', key: 'trust', value: 2 },
          { type: 'stat', key: 'evidence', value: 1 },
        ],
        next: 'r3-20e1-bottle-reply',
      },
      {
        id: 'bottle-night-return-unopened',
        label: '原样退回：“今晚我只看见一个文件名。”',
        tone: 'secret',
        effects: [
          { type: 'flag', key: 'r3NightBottleDone' },
          { type: 'relationship', character: 'bottle', key: 'trust', value: 1 },
          { type: 'organizationRelation', organization: 'org1', value: 1 },
        ],
        next: 'r3-20e2-bottle-reply',
      },
    ],
  },
  {
    id: 'r3-20e1-bottle-reply',
    chapter: 'epilogue',
    actLabel: '尾声 · 外组来客的保温杯',
    date: '2026-07-28',
    location: '顶级奶瓶 · 跨组织私聊',
    mode: 'chat',
    speaker: 'bottle',
    portrait: 'bottle',
    text: '这就对了。表格能交流，人的备注不能当伴手礼。空模板明早发你，祈福那条提醒我会郑重地复制回去。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r3-20a-night-hub',
  },
  {
    id: 'r3-20e2-bottle-reply',
    chapter: 'epilogue',
    actLabel: '尾声 · 外组来客的保温杯',
    date: '2026-07-28',
    location: '顶级奶瓶 · 跨组织私聊',
    mode: 'chat',
    speaker: 'bottle',
    portrait: 'bottle',
    text: '收到。那我也只收到一个没打开的文件。新区难得有人肯让八卦在下载进度百分之零的时候寿终正寝。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r3-20a-night-hub',
  },
  {
    id: 'r3-20f-jiangjinjiu-night',
    chapter: 'epilogue',
    actLabel: '尾声 · 白猫符纸',
    date: '2026-07-28',
    location: '将进酒 · 私聊',
    mode: 'chat',
    speaker: 'jiangjinjiu',
    portrait: 'jiangjinjiu',
    text: '先声明，这不是入组申请，也不是谁把谁变成宠物。是我在老区学过的一张灵兽形态符：我可以暂时变成会说话的白猫，帮你巡夜，也随时能自己停。你不喜欢，我现在就把符烧掉。',
    background: 'nightMessage',
    historical: 'fictional',
    presentation: {
      ui: 'classic', transition: 'ink', camera: 'push-in', atmosphere: 'paper',
      sprites: [{ character: 'jiangjinjiu', expression: 'soft', pose: 'thinking', position: 'center', scale: .98 }],
    },
    choices: [
      {
        id: 'jiangjinjiu-pet-refuse-now',
        label: '“不用变。你以人的样子留下来聊天就好。”',
        tone: 'warm',
        effects: [
          { type: 'flag', key: 'r3NightJiangjinjiuDone' },
          { type: 'relationship', character: 'jiangjinjiu', key: 'trust', value: 1 },
        ],
        next: 'r3-20f0-pet-refused',
      },
      {
        id: 'jiangjinjiu-pet-hear-terms',
        label: '“先把边界逐条说完，再由你决定要不要试。”',
        tone: 'calm',
        next: 'r3-20f1-pet-terms',
      },
    ],
  },
  {
    id: 'r3-20f0-pet-refused',
    chapter: 'epilogue',
    actLabel: '尾声 · 白猫符纸',
    date: '2026-07-28',
    location: '将进酒 · 私聊',
    mode: 'chat',
    speaker: 'jiangjinjiu',
    portrait: 'jiangjinjiu',
    text: '好，那就不变。你不需要为拒绝补偿我。符纸我收回；等风小一点，你还欠我一局普通的夜巡。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r3-20a-night-hub',
  },
  {
    id: 'r3-20f1-pet-terms',
    chapter: 'epilogue',
    actLabel: '尾声 · 灵兽契约',
    date: '2026-07-28',
    location: '将进酒 · 私聊',
    mode: 'novel',
    speaker: 'jiangjinjiu',
    portrait: 'jiangjinjiu',
    text: '边界有四条：第一，我仍然是能说话、能拒绝的将进酒；第二，不接受命令、占有或私密用途；第三，双方都能随时解除，不问理由；第四，只在今晚巡夜时生效，天亮便自动解除。你同意这些，我才亲手落印。',
    background: 'nightMessage',
    historical: 'fictional',
    choices: [
      {
        id: 'jiangjinjiu-pet-contract',
        label: '“四条都同意。由你落印，也由你随时停下。”',
        tone: 'warm',
        effects: [
          { type: 'flag', key: 'r3NightJiangjinjiuDone' },
          { type: 'flag', key: 'jiangjinjiuPetContracted' },
          { type: 'relationship', character: 'jiangjinjiu', key: 'trust', value: 2 },
          { type: 'relationship', character: 'jiangjinjiu', key: 'affinity', value: 1 },
          { type: 'unlockEnding', id: 'pet-jiangjinjiu' },
          { type: 'unlockCg', id: 'cg48-pet-jiangjinjiu' },
        ],
        next: 'r3-20f2-pet-contracted',
      },
      {
        id: 'jiangjinjiu-pet-decline-after-terms',
        label: '“边界清楚了，但今晚不签。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'r3NightJiangjinjiuDone' },
          { type: 'relationship', character: 'jiangjinjiu', key: 'trust', value: 1 },
        ],
        next: 'r3-20f3-pet-declined-after-terms',
      },
    ],
  },
  {
    id: 'r3-20f2-pet-contracted',
    chapter: 'epilogue',
    actLabel: '尾声 · 灵兽契约',
    date: '2026-07-28',
    title: '白猫夜巡',
    location: '抚梅观清雪 · 屋檐',
    mode: 'chat',
    speaker: 'jiangjinjiu',
    portrait: 'jiangjinjiu',
    text: '符纸亮过一圈，她以白猫灵兽的形态落在窗台，第一句话仍然完整：“先说好，我是巡夜搭档，不是自动拾取宠物。还有，你们组织屋檐漏雨，明天记得修。”',
    background: 'nightMessage',
    historical: 'fictional',
    presentation: {
      cg: cgPath('cg48-pet-jiangjinjiu'),
      cgAlt: '将进酒在明确同意与可随时解除的灵兽契约下，化为能交流的白猫形态与玩家并肩巡夜',
      ui: 'cinematic', transition: 'ink', camera: 'push-in', atmosphere: 'petals', focus: 'center',
    },
    next: 'r3-20a-night-hub',
  },
  {
    id: 'r3-20f3-pet-declined-after-terms',
    chapter: 'epilogue',
    actLabel: '尾声 · 灵兽契约',
    date: '2026-07-28',
    location: '将进酒 · 私聊',
    mode: 'chat',
    speaker: 'jiangjinjiu',
    portrait: 'jiangjinjiu',
    text: '明白。边界说清不是为了催你签，是为了让“不签”也很轻松。符纸夹回书里，今晚我们用两条腿巡夜。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r3-20a-night-hub',
  },
  {
    id: 'r3-20f4-pet-released',
    chapter: 'epilogue',
    actLabel: '尾声 · 契约解除',
    date: '2026-07-28',
    location: '抚梅观清雪 · 屋檐',
    mode: 'chat',
    speaker: 'jiangjinjiu',
    portrait: 'jiangjinjiu',
    text: '符纸从中线自行断开，白猫的影子舒展开，她恢复原本的模样：“解除确认。我留一张屋檐上的合照作纪念，今晚的契约到这里。你看，说随时停，就真的会停。”',
    background: 'nightMessage',
    historical: 'fictional',
    presentation: {
      ui: 'classic', transition: 'ink', camera: 'pull-back', atmosphere: 'petals',
      sprites: [{ character: 'jiangjinjiu', expression: 'smile', pose: 'relaxed', position: 'center', scale: 1.02 }],
    },
    next: 'r3-20a-night-hub',
  },
  {
    id: 'r3-21-bond-router',
    chapter: 'epilogue',
    actLabel: '尾声 · 私聊窗口',
    date: '2026-07-28',
    location: '深夜私聊',
    mode: 'chat',
    speaker: 'truth',
    portrait: 'truth',
    text: '最后一份职位表我核完了。证据栏里没有写你应该回复谁，那不是职位表能替你决定的事。还亮着的私聊都在下面；你也可以把关系停在同伴这里。',
    background: 'nightMessage',
    choices: [
      {
        id: 'choose-heartbeat-bond',
        label: '回心跳：“下一份名单，先只发给我。”',
        tone: 'warm',
        // v1.4 的结局前存档会在迁移层按旧门槛补满进度，运行时只保留一套判定。
        condition: {
          type: 'all',
          conditions: [
            { type: 'relationshipProgress', character: 'heartbeat', operator: 'gte', value: 100 },
            { type: 'relationship', character: 'heartbeat', key: 'trust', operator: 'gte', value: 4 },
            { type: 'relationship', character: 'heartbeat', key: 'affinity', operator: 'gte', value: 3 },
          ],
        },
        next: 'r3-22-bond-heartbeat',
      },
      {
        id: 'choose-qifu-bond',
        label: '回祈福：“下线以后，我们把软话说完。”',
        tone: 'warm',
        condition: {
          type: 'all',
          conditions: [
            { type: 'flag', key: 'privateTalkWithQifu' },
            { type: 'flag', key: 'qifuAccountabilityRespected' },
            { type: 'relationshipProgress', character: 'qifu', operator: 'gte', value: 100 },
            { type: 'relationship', character: 'qifu', key: 'trust', operator: 'gte', value: 3 },
            { type: 'relationship', character: 'qifu', key: 'affinity', operator: 'gte', value: 2 },
          ],
        },
        next: 'r3-22-bond-qifu',
      },
      {
        id: 'keep-night-friendship',
        label: '关掉私聊：“今晚先做彼此可靠的同伴。”',
        tone: 'calm',
        next: 'r3-23-ending-router',
      },
    ],
  },
  bondEndingNode({
    id: 'r3-22-bond-heartbeat',
    actLabel: '尾声 · 只告诉你',
    location: '三组管理私聊',
    character: 'heartbeat',
    text: '我还是会先看见机会。你还是会先问位置够不够。正好，下一次我想把谁拉进来，先只告诉你。不是首领群，是私聊。',
    cg: cgPath('cg18-bond-heartbeat'),
    cgAlt: '空荡的三组管理室里，心跳成瘾把只属于两人的私聊递到玩家面前',
    cgId: 'cg18-bond-heartbeat',
    atmosphere: 'messages',
    next: 'r3-23-ending-router',
  }),
  // 祈福的两条攻略路径共用同一张结局母图，文字与状态仍由各路线独立结算。
  bondEndingNode({
    id: 'r3-22-bond-qifu',
    actLabel: '尾声 · 下线以后',
    location: '旧4945区群之外',
    character: 'qifu',
    text: '你没有加入我的声明，也没有趁我掉管理员时发公告。三组首领和一组首领不需要在群里说软话。下线以后，可以。',
    cg: cgPath('cg17-bond-qifu'),
    cgAlt: '离开4945区群的夜晚，祈福在天台递来一杯热饮，管理员徽章被留在一旁',
    cgId: 'cg17-bond-qifu',
    next: 'r3-23-ending-router',
  }),
  {
    id: 'r3-23-ending-router',
    chapter: 'epilogue',
    actLabel: '尾声 · 最后一份成员表',
    date: '2026-07-28',
    location: '抚梅观清雪 · 管理群',
    mode: 'chat',
    speaker: 'truth',
    portrait: 'truth',
    text: '新成员、旧成员、盟友，还有那些被你拒绝过的申请，我都写进最后一份表了。群里有人在等明天的出勤安排。这次不要我解释，你自己发。',
    background: 'ending',
    next: {
      cases: [
        // ── 蝴蝶效应 · 路线变体结局 ──
        { when: { type: 'flag', key: 'bf_shadow_master' }, next: 'r3-end-schemer' },
        { when: { type: 'flag', key: 'bf_peacemaker' }, next: 'r3-end-diplomat' },
        { when: { type: 'flag', key: 'bf_ruthless' }, next: 'r3-end-cold-tyranny' },
        // ── 原有分流逻辑 ──
        { when: { type: 'stat', key: 'cohesion', operator: 'lte', value: 1 }, next: 'r3-end-talent-market' },
        { when: { type: 'flag', key: 'org3RefusedAbsorption' }, next: 'r3-end-successful-refusal' },
        {
          when: {
            type: 'all',
            conditions: [
              { type: 'stat', key: 'resources', operator: 'gte', value: 4 },
              { type: 'stat', key: 'reputation', operator: 'lte', value: 0 },
            ],
          },
          next: 'r3-end-expansion-empire',
        },
      ],
      fallback: 'r3-end-alliance-hub',
    },
  },
  {
    id: 'r3-end-alliance-hub',
    chapter: 'epilogue',
    actLabel: '尾声 · 联盟中枢',
    date: '2026-07-28',
    title: '联盟中枢',
    location: '4945区',
    mode: 'ending',
    speaker: 'narrator',
    text: '三组没有成为最大数字，却成了每次谈判都绕不开的中枢。新人知道自己为什么能来，旧成员知道位置不会凭战力自动消失。你吸收的不是所有人，而是一套让人愿意继续留下的办法。',
    background: 'ending',
    music: 'afterOnline',
    presentation: {
      cg: cgPath('cg35-ending-route3'),
      cgAlt: '抚梅观清雪的多扇门在清晨同时开启，成员与盟友沿不同路径来往而不被合并',
      ui: 'ending',
      transition: 'crossfade',
      camera: 'drift-right',
      atmosphere: 'petals',
      focus: 'center',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'r3-alliance-hub' },
      { type: 'unlockCg', id: 'cg35-ending-route3' },
    ],
    next: 'worldline-check',
  },
  {
    id: 'r3-end-talent-market',
    chapter: 'epilogue',
    actLabel: '尾声 · 人才市场',
    date: '2026-07-28',
    title: '人才市场',
    location: '4945区',
    mode: 'ending',
    speaker: 'narrator',
    text: '所有想换组织的人都先来三组，所有进入三组的人也都保留下一份申请。排行榜数字上升，管理群里却每天都像入职与离职同时进行。这里人人愿意来，没人确信自己会留下。',
    background: 'ending',
    music: 'afterOnline',
    presentation: {
      cg: cgPath('cg35-ending-route3'),
      cgAlt: '抚梅观清雪的申请托盘堆满，成员光影穿过多扇门，组织像一个永不休息的人才市场',
      ui: 'ending',
      transition: 'slide',
      camera: 'drift-left',
      atmosphere: 'messages',
      focus: 'right',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'r3-talent-market' },
      { type: 'unlockCg', id: 'cg35-ending-route3' },
    ],
    next: 'worldline-check',
  },
  {
    id: 'r3-end-expansion-empire',
    chapter: 'epilogue',
    actLabel: '尾声 · 扩张帝国',
    date: '2026-07-28',
    title: '扩张帝国',
    location: '4945区',
    mode: 'ending',
    speaker: 'narrator',
    text: '三组吸收了战败者、争议者和离开者，资源终于足以与前两组并列谈判。只是每个组织都开始提前防着你挖人。你证明扩张有效，也让全区学会了如何对付扩张。',
    background: 'ending',
    music: 'afterOnline',
    presentation: {
      cg: cgPath('cg35-ending-route3'),
      cgAlt: '人员路径从抚梅观清雪向整个4945区扩张，规则册被越来越多的申请压在桌角',
      ui: 'ending',
      transition: 'flash',
      camera: 'push-in',
      atmosphere: 'danmaku',
      focus: 'center',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'r3-expansion-empire' },
      { type: 'unlockCg', id: 'cg35-ending-route3' },
    ],
    next: 'worldline-check',
  },
  {
    id: 'r3-end-successful-refusal',
    chapter: 'epilogue',
    actLabel: '尾声 · 一次成功的拒绝',
    date: '2026-07-28',
    title: '一次成功的拒绝',
    location: '4945区',
    mode: 'ending',
    speaker: 'narrator',
    text: '你没有吞下五组最脆弱的那一刻。三组少了一截立即增长，却得到一个不会因为利益变化就失效的盟友。新区第一次有人发现，拒绝扩张也可以是一种扩张。',
    background: 'ending',
    music: 'afterOnline',
    presentation: {
      cg: cgPath('cg35-ending-route3'),
      cgAlt: '抚梅观清雪保留少数清晰路径，关闭的规则册与未收下的申请共同证明一次成功拒绝',
      ui: 'ending',
      transition: 'crossfade',
      camera: 'pull-back',
      atmosphere: 'petals',
      focus: 'left',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'r3-successful-refusal' },
      { type: 'unlockCg', id: 'cg35-ending-route3' },
    ],
    next: 'worldline-check',
  },

  // ──────────────── 蝴蝶效应 · 变体结局 ────────────────
  {
    id: 'r3-end-diplomat',
    chapter: 'epilogue', actLabel: '终幕 · 外交家', date: '2026-07-28',
    title: '外交家', location: '4945区', mode: 'ending', speaker: 'narrator',
    text: '三组没有征服任何人，却成了所有人信得过的第三方。你参加的不是谈判，而是几乎没有协议的共识；你签下的不是条约，而是一句"先去问三组"的习惯。权柄不以战书传递，以面子。',
    background: 'ending', music: 'afterOnline',
    presentation: {
      cg: cgPath('cg35-ending-route3'),
      cgAlt: '抚梅观清雪圆桌上六个组织的信物环放，没有合约，只有一杯留给下一位来客的温茶',
      ui: 'ending-triumph', transition: 'crossfade', camera: 'pull-back', atmosphere: 'petals', focus: 'center',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'r3-diplomat' },
      { type: 'unlockCg', id: 'cg35-ending-route3' },
    ],
    next: 'worldline-check',
  },
  {
    id: 'r3-end-cold-tyranny',
    chapter: 'epilogue', actLabel: '终幕 · 冷血经营', date: '2026-07-28',
    title: '冷血经营', location: '4945区', mode: 'ending', speaker: 'narrator',
    text: '三组的KPI全绿。成员稳定，资源充裕，审批流程没有冗余。唯一的口头问题是新人在入群第一周问："这里有人会在下班后聊天吗？"系统里的回答是"建议使用非工作群"。',
    background: 'ending', music: 'afterOnline',
    presentation: {
      cg: cgPath('cg35-ending-route3'),
      cgAlt: '抚梅观清雪桌上整齐排列着效率报表，成员椅各就各位，但没有一盏聊天灯亮着',
      ui: 'ending-dark', transition: 'flash', camera: 'push-in', atmosphere: 'none', focus: 'center',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'r3-cold-tyranny' },
      { type: 'unlockCg', id: 'cg35-ending-route3' },
    ],
    next: 'worldline-check',
  },
  {
    id: 'r3-end-schemer',
    chapter: 'epilogue', actLabel: '终幕 · 棋手', date: '2026-07-28',
    title: '棋手', location: '？？？', mode: 'ending', speaker: 'narrator',
    text: '你从第一天就开始记录每个人的弱点与期望。不是恶意，你只是比任何人都先一步替他们做好了他们会做的决定。三组成功了，不是因为你比对手聪明，而是对手的每一步都在你的计算之内——包括对手并不知道这一点。',
    background: 'ending', music: 'afterOnline',
    presentation: {
      cg: cgPath('cg35-ending-route3'),
      cgAlt: '抚梅观清雪管理室半掩，桌上规则册堆叠如棋局，窗外无人知晓最后一步是谁走出',
      ui: 'ending-secret', transition: 'crossfade', camera: 'pull-back', atmosphere: 'paper', focus: 'center',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'r3-schemer' },
      { type: 'unlockCg', id: 'cg35-ending-route3' },
    ],
    next: 'worldline-check',
  },
] satisfies StoryNode[]
